import { ReactNode } from 'react';
import { Button, ButtonProps } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useAppContext } from 'src/app/modules/appContext/AppContext';
import { asyncWrapper } from 'src/app/modules/utils/AppFunction';
import { E_MEDICAL_RECORD_SYSTEM } from 'src/app/modules/utils/Constant';
import { getEMedicalRecordLink } from '../../services/BenhAnServices';

type Props = Pick<ButtonProps, 'disabled' | 'className' | 'onClick'> & {
	params: {
		medicalRecordCode: string;
	};
	system?: string;
	label?: ReactNode;
};

const EMedicalRecordButton = ({
	params,
	system = E_MEDICAL_RECORD_SYSTEM.ELSAGA,
	label = 'Bệnh án điện tử',
	...props
}: Props) => {
	const { setIsLoading } = useAppContext();

	const viewMedicalRecord = async () => {
		if (!params?.medicalRecordCode) {
			toast.error('Không có mã hồ sơ bệnh án, vui lòng bổ sung thông tin.');
			return;
		}

		const [data] = await asyncWrapper(
			getEMedicalRecordLink({
				medicalRecordCode: params.medicalRecordCode,
				system: system,
			}),
			setIsLoading
		);

		if (!data) return;

		window.open(data, '_blank');
	};

	return (
		<Button onClick={viewMedicalRecord} {...props}>
			{label}
		</Button>
	);
};

export default EMedicalRecordButton;
